import * as React from "react";
import * as ReactDOM from "react-dom";
import Ajax from "../../Ajax";
import EditOrder from "./EditOrder";
import NewOrder from "./NewOrder";
import OrdersDatatable from "./OrdersDatatable";


interface IFormProps {
}
interface MyStates {
  add_new: boolean,
  edit_id: number,
}
export default class CreateOrder extends React.Component<IFormProps, MyStates>{

  constructor(props:IFormProps) {
    super(props);

    this.state = {
      add_new: false,
      edit_id: 0,
    }
  }

  private setForEdit( id ) {
    this.setState({
      add_new: false,
      edit_id: id
    })
  }

  private addNew( ) {
    this.setState({
      add_new: true,
      edit_id: 0
    })
  }
  private dontAddNew( ) {
    this.setState({
      add_new: false,
      edit_id: 0
    })
  }

  public render() {
      return (
      <>
        <div className="row">
          <div className="col-md-10 col-md-offset-1" key={'editfield_' + Math.random()}>
             <NewOrder setForEdit={(e) => this.setForEdit(e)} dontAddNew={() => this.dontAddNew() } />
          </div>
        </div>
      </>
      );
  }
}

export class InitCreateOrder {
  constructor() {
      var div: HTMLDivElement = document.getElementById('create_order_app') as HTMLDivElement;
      if (div !== null) {
          var data:any = div.dataset;
          ReactDOM.render(<CreateOrder />, div);
      }
  }
}